import { render, staticRenderFns } from "./energyAnalysis.vue?vue&type=template&id=488cbb30&scoped=true"
import script from "./energyAnalysis.vue?vue&type=script&lang=js"
export * from "./energyAnalysis.vue?vue&type=script&lang=js"
import style0 from "./energyAnalysis.vue?vue&type=style&index=0&id=488cbb30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488cbb30",
  null
  
)

export default component.exports